export default {
  toolbar: {
    minHeight: 78
  }
};
